export enum StatisticObjectEnum {
    COMPANY = 'company',
    STORE_GROUP = 'store_group',
    STORE = 'store',
    STORE_CLUSTER = 'store_cluster',
}
